import Swal from "sweetalert2";

export const basicTimerMsg = (title) => {
    Swal.fire({ title, timer: 3000, confirmButtonText: 'Aceptar', icon: 'error' });
};